import { c as _c } from "react/compiler-runtime";
import { MANAGE_SUBSCRIPTIONS_API } from 'modules/profile/manage-subscriptions/api/cancel-subscriptions-api';
import { ManageSubscriptionsApiInterface } from 'modules/profile/manage-subscriptions/types/manage-subscriptions-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { SwrPaginationInterface } from 'shared/types/pagination-interface';
import useSWR from 'swr';
interface UseManageSubscriptionsInterface extends SwrPaginationInterface {}
export function useManageSubscriptions(t0) {
  const $ = _c(5);
  const {
    limit,
    pagination
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== limit || $[2] !== pagination || $[3] !== user) {
    t2 = () => {
      if (user && pagination.startFromId === undefined && limit) {
        return `${MANAGE_SUBSCRIPTIONS_API}/list?pagination[limit]=${limit}`;
      } else {
        if (user && pagination.startFromId && limit) {
          return `${MANAGE_SUBSCRIPTIONS_API}/list?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}`;
        }
      }
    };
    $[1] = limit;
    $[2] = pagination;
    $[3] = user;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return useSWR(t2, fetcher);
}